import CrazyArrow from './CrazyArrow';

export default CrazyArrow;